import { Formatters } from "@/hooks/useFormatters";

interface DatePrecision {
  year: boolean;
  month: boolean;
  day: boolean;
  hour: boolean;
  minute: boolean;
  second: boolean;
}

const getDatePrecision = (date: Date): DatePrecision => {
  return {
    second: true,
    minute: date.getSeconds() ===  0,
    hour: date.getMinutes() === 0,
    day: date.getHours() === 0,
    month: date.getDate() === 1,
    year: date.getMonth() === 0,
  };
};

type DateFormatLevel = 'year' | 'month' | 'day' | 'hour' | 'minute' | 'second';

const getFormatLevel = (precision: DatePrecision): DateFormatLevel => {
  if (precision.year) return 'year';
  if (precision.month) return 'month';
  if (precision.day) return 'day';
  if (precision.hour) return 'hour';
  if (precision.minute) return 'minute';
  return 'second';
};

const formatByLevel: Record<DateFormatLevel, (formatters: Formatters, date: Date) => string> = {
  year: (formatters, date) =>
    formatters.formatDateTime(date, { year: 'numeric' }),

  month: (formatters, date) =>
    `{month|${formatters.formatDateTime(date, { month: 'short' })}}`,

  day: (formatters, date) =>
    formatters.formatDateTime(date, { day: 'numeric', month: 'short' }),

  hour: (formatters, date) =>
    formatters.formatDateTime(date, {
      hour: 'numeric',
      minute: 'numeric',
    }),

  minute: (formatters, date) => 
    formatters.formatDateTime((date), {
      hour: 'numeric',
      minute: 'numeric',
    }),
  

  second: (formatters, date) =>
    formatters.formatDateTime(date, {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    }), 
};

export const formatXAxisPointer = (
  value: number,
  formatters: Formatters | null
): string => {
  const date = new Date(value);

  if (!formatters) {
    return date.toLocaleString();
  }

  return formatters.formatDateTime(date);
}

export const formatXAxisLabel = (
  value: number | string,
  formatters: Formatters | null
): string => {
  const date = new Date(value);

  if (!formatters) {
    return date.toLocaleString();
  }
  const precision = getDatePrecision(date);
  const level = getFormatLevel(precision);

  return formatByLevel[level](formatters, date);
}
